import { render, staticRenderFns } from "./ed-subdeck-viewer.component.vue?vue&type=template&id=a62c61d4&scoped=true&"
import script from "./ed-subdeck-viewer.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subdeck-viewer.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subdeck-viewer.component.scss?vue&type=style&index=0&id=a62c61d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62c61d4",
  null
  
)

export default component.exports